import { isOwnerOnlyActionKey } from '@/@types/TeamMember';
import { api } from './api';

export interface ISellerAreaAction {
  id: number;
  key: string;
  name: string;
  description: string;
  group: string;
}

export interface IPermissionCategory {
  group: string;
  permissions: string[];
}

export const TeamActionsService = {
  getActions: async (): Promise<ISellerAreaAction[]> => {
    const response = await api.get('/v1/settings/team/actions');
    const actions: ISellerAreaAction[] = response.data?.data ?? response.data ?? [];
    return actions.filter((action) => !isOwnerOnlyActionKey(action.key));
  },

  /**
   * Agrupa ação plana em categorias: { group → string[] das keys }
   */
  groupByCategory: (actions: ISellerAreaAction[]): Record<string, string[]> => {
    const result: Record<string, string[]> = {};
    for (const action of actions) {
      if (isOwnerOnlyActionKey(action.key)) {
        continue;
      }
      const group = action.group || 'general';
      if (!result[group]) result[group] = [];
      result[group].push(action.key);
    }
    return result;
  },
};
